<div class="card h-100 card-no-border mt-4">
    <div class="card-body no-padding">
        <cfg-table [resource]="dbTablesResource" [columns]="columns" [trackBy]="trackById"
            [searchFields]="['name', 'displayName', 'tableName', 'displayObjectType']"
            searchParam="search" searchStorageKey="db-templates"
            [defaultSort]="defaultSort" [rowLink]="rowLink"
            emptyText="Ingen databaseskabeloner at vise." loadingText="Indlæser lister"
            errorText="Fejl under indlæsning af databaseskabelonliste" />
    </div>
</div>
